import { Node_Type } from "./../../ricos-types";
import Image from "./viewer-image";
const nodeViewRenderers = {
  [Node_Type.IMAGE]: Image
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
